// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"435":"08dfb054","691":"eea6bf72","787":"8ccc0ce1"}[chunkId] + ".chunk.js";
};